import React from 'react';
import { Routes, Route, useLocation, Navigate, useParams } from 'react-router-dom';
import LandingPage from './LandingPage';
import Navbar from './Navbar';
import Upload from './Upload';
import Admin from './Admin';
import Wizard from './Wizard';
import ProjectList from './ProjectList';
import Dashboard from './Dashboard';
import Production from './Production';
import ForumCollaboratif from './ForumCollaboratif';
import ProjectContribute from './ProjectContribute';
import JourneyAdmin from './JourneyAdmin';
import ScenarioEditor from './ScenarioEditor';
import AccountPage from './AccountPage';
import SettingsPage from './SettingsPage';
import BillingPage from './BillingPage';
import BillingAdminPage from './BillingAdminPage';
import AccountSettingsPage from './AccountSettingsPage';
import UserProfilePage from './UserProfilePage';
import ProjectRecapWrapper from './ProjectRecapWrapper';
import { GroupList, GroupCreate, GroupDetail } from './GroupModule';
import UserProfile from './UserProfile';
import AuthHandler from './AuthHandler';
import NotificationsPage from './NotificationsPage';
import AccessLogPage from './AccessLogPage';
const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("kc_token");
  return token ? children : <Navigate to="/" />;
};

const GroupDetailWrapper = () => {
  const { groupId } = useParams();
  return <GroupDetail groupId={groupId} />;
};

const UserProfileWrapper = () => {
  const { username } = useParams();
  return <UserProfile username={username} />;
};

const AppRoutes = ({ onLogout }) => {
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const token = localStorage.getItem("kc_token");
  const isAuthenticated = !!token;

  return (
    <>
      {isAuthenticated && !isLanding ? (
        <div className="d-flex">
          <Navbar onLogout={onLogout} />
          <main style={{ paddingLeft: '10px', width: '100%' }}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/upload" element={<RequireAuth><Upload /></RequireAuth>} />
              <Route path="/wizard" element={<RequireAuth><Wizard /></RequireAuth>} />
              <Route path="/projects" element={<RequireAuth><ProjectList /></RequireAuth>} />
              <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/production" element={<RequireAuth><Production /></RequireAuth>} />
              <Route path="/forum" element={<RequireAuth><ForumCollaboratif /></RequireAuth>} />
              <Route path="/project/:id" element={<RequireAuth><ProjectContribute /></RequireAuth>} />
              <Route path="/project/:id/manage" element={<RequireAuth><JourneyAdmin /></RequireAuth>} />
              <Route path="/project/:id/scenario" element={<RequireAuth><ScenarioEditor /></RequireAuth>} />
              <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
              <Route path="/projects/:id/recap" element={<RequireAuth><ProjectRecapWrapper /></RequireAuth>} />
              <Route path="/groups" element={<RequireAuth><GroupList /></RequireAuth>} />
              <Route path="/groups/create" element={<RequireAuth><GroupCreate /></RequireAuth>} />
              <Route path="/groups/:groupId" element={<RequireAuth><GroupDetailWrapper /></RequireAuth>} />
              <Route path="/users/:username" element={<RequireAuth><UserProfileWrapper /></RequireAuth>} />
              <Route path="/account" element={<RequireAuth><AccountPage /></RequireAuth>} />
              <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
              <Route path="/billing" element={<RequireAuth><BillingPage /></RequireAuth>} />
              <Route path="/admin/billing" element={<RequireAuth><BillingAdminPage /></RequireAuth>} />
              <Route path="/settings/account" element={<RequireAuth><AccountSettingsPage /></RequireAuth>} />
              <Route path="/profile/:username" element={<RequireAuth><UserProfilePage /></RequireAuth>} />
              <Route path="/auth/callback" element={<AuthHandler />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/admin/access-log" element={<AccessLogPage />} />
            </Routes>
          </main>
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      )}
    </>
  );
};

export default AppRoutes;
